<template>
	<teleport to="body">
		<div class="app-dialog" :class="isVisible? 'visible': 'not-visible'" :style="zIndex ? { zIndex: zIndex - 1 } : {}">
			<div class="app-dialog__backdrop" :style="zIndex ? { zIndex: zIndex } : {}" @click="$emit('close')"></div>

			<!--			<transition appear name="gsap-pop" :css="false" @enter="enterModal" @leave="leaveModal">-->
			<div
				class="app-dialog__panel"
				:style="zIndex ? { zIndex: zIndex + 2 } : {}"
				:class="{
						'app-dialog--fullscreen': isFullscreen,
						'app-dialog__panel--compact': isCompact,
						'app-dialog__panel--lg': isLg,
						'app-dialog__standar': $route.path === '/take-away-delivery'
					}"
			>
				<header class="app-dialog__header" v-if="$slots.header || title !== '' || close">
					<div class="app-flex-start-container w-100">
						<template v-if="$slots.header">
							<slot name="header" />
						</template>
						<template v-else>
							<h5 class="app-dialog__title m-0 ">{{ title }}</h5>
						</template>
						<button v-if="close" class="app-dialog__close  flex-none" @click="$emit('close')">
							<XmarkIcon />
						</button>
					</div>
				</header>

				<div class="app-dialog__body" ref="appDialogBody" :class="notPaddingBody? 'p-0':''">
					<slot />
				</div>

				<footer v-if="$slots.footer || $slots['footer-top']" :class="['app-dialog__footer', { 'app-dialog__footer--column': $slots['footer-top'] }]">
					<!-- Si existe el slot footer-top, lo renderizamos en un div -->
					<template v-if="$slots['footer-top']">
						<div class="footer-top-slot">
							<slot name="footer-top" />
						</div>
						<!-- Y los botones en otro div, para columna -->
						<div class="footer-bottom-slot">
							<slot name="footer" />
						</div>
					</template>

					<!-- Si NO hay footer-top, renderiza los botones directamente -->
					<template v-else>
						<slot name="footer" />
					</template>
				</footer>
			</div>
			<!--			</transition>-->
		</div>
	</teleport>
</template>

<script>
import XmarkIcon from '@/core/icons/XmarkIcon.vue'

export default {
	name: 'AppModal',
	emits: ['close'],
	components: { XmarkIcon },
	props: {
		title: {
			type: String,
			default: ''
		},
		close: {
			type: Boolean,
			default: false
		},
		isFullscreen: {
			type: Boolean,
			default: false
		},
		isCompact: {
			type: Boolean,
			default: false
		},
		isLg: {
			type: Boolean,
			default: false
		},
		zIndex: {
			type: Number,
			default: null
		},
		notPaddingBody: {
			type: Boolean,
			default: false
		},
		isVisible: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		isVisible(newVal) {
			if (newVal) {
				document.body.classList.add('modal-open')
			} else {
				document.body.classList.remove('modal-open')
			}
		}
	},
	mounted() {
		if (this.isVisible) {
			document.body.classList.add('modal-open')
		}
	},
	beforeUnmount() {
		document.body.classList.remove('modal-open')
	},
	methods: {
		/*enterModal(el, done) {
			gsap.killTweensOf(el);
			gsap.set(el, { willChange: 'opacity', autoAlpha: 0 });
			gsap.to(el, {
				autoAlpha: 1,
				duration: 0.12,
				ease: 'none',
				lazy: false,
				onComplete: () => {
					gsap.set(el, { clearProps: 'will-change' });
					done();
				}
			});
		},
		leaveModal(el, done) {
			gsap.killTweensOf(el);
			gsap.set(el, { willChange: 'opacity' });
			gsap.to(el, {
				autoAlpha: 0,
				duration: 0.12,
				ease: 'none',
				lazy: false,
				onComplete: () => {
					gsap.set(el, { clearProps: 'will-change' });
					done();
				}
			});
		}*/
	}

}
</script>

<style scoped></style>
